import { useState } from 'react'
import styled from 'styled-components'
import SelectButton from 'src/components/form/SelectButton'
import { StyledButton } from 'src/styles/Button'
import grabColor from 'src/utils/grabColor'

function MoreOptions({ options, moreOptions, value, handleClick, name, label, note }) {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => setIsOpen((o) => !o)
  const whichOptions = isOpen ? moreOptions : options
  return (
    <div>
      <LabelWrapper>
        {label && <InputLabelFeatured>{label}</InputLabelFeatured>}
        {note && (
          <InputNote>
            {note} <NoteMetaPlaceholder />
          </InputNote>
        )}
      </LabelWrapper>
      <OptionsWrapper>
        {whichOptions.map((option, index) => (
          <SelectButton
            key={index}
            selected={option.value === value}
            value={option.value}
            name={name}
            onClick={handleClick}
            type="button"
          >
            {option.placeholder}
          </SelectButton>
        ))}
      </OptionsWrapper>
      {moreOptions && (
        <ButtonWrapper>
          <StyledButton onClick={toggleOpen} variant="primary" size="large" type="button">
            List {isOpen ? 'Less' : 'More'} &rarr;
          </StyledButton>
        </ButtonWrapper>
      )}
    </div>
  )
}

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 3rem auto 1rem;
`

const NoteMetaPlaceholder = styled.div`
  margin: 0 1rem 0 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.1);
`

const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const OptionsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 1rem 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    flex-direction: column;
  }
`

const InputNote = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${grabColor('detail')};
  display: flex;
  align-items: center;
  gap: 8px;
`

const InputLabelFeatured = styled.h3`
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  color: ${grabColor('heading')};
  margin: 0;
`

export default MoreOptions
